// store.js
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";

import userReducer from "app/slices/user/userSlice";
import { apiService } from "api/apiService";

const persistConfig = {
  key: "user",
  storage: sessionStorage,
  whitelist: ["model"],
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

const middlewares = [apiService.middleware];

export const makeStore = (preloadedState) => {
  const store = configureStore({
    reducer: {
      user: persistedUserReducer,
      [apiService.reducerPath]: apiService.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(...middlewares),
    preloadedState,
  });
  setupListeners(store.dispatch);
  return store;
};

export const store = makeStore();
export const persistor = persistStore(store);
